import React from 'react';

const FilteredSheetTable = ({
  data,
  selectedRows,
  updateSelectedRows,
  columnKeys,
  updateColumnKey,
  onParse,
  updateAllSelection,
}) => {
  const isAllSelected = data.length > 0 && data.every((_, i) => selectedRows.has(i));

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    const newSet = new Set();
    if (checked) {
      data.forEach((_, i) => newSet.add(i));
    }
    updateAllSelection(newSet);
  };

  return (
    <div className="space-y-4">
      <button
        onClick={onParse}
        className="px-4 py-2 bg-green-600 text-white rounded"
      >
        Parse Data
      </button>

      <div className="overflow-x-auto overflow-y-auto max-h-[60vh]">
        <table className="min-w-full table-auto border">
          <thead>
            <tr>
              <th className="border p-2">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAllChange}
                  className="mr-2"
                />
                #
              </th>
              {columnKeys.map((key, i) => (
                <th key={i} className="border p-2">
                  <input
                    value={key}
                    onChange={(e) => updateColumnKey(i, e.target.value)}
                    className="border px-1 py-0.5 rounded w-full"
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr
                key={i}
                className={`border ${selectedRows.has(i) ? 'bg-blue-100' : ''}`}
              >
                <td className="border p-2">
                  <input
                    type="checkbox"
                    checked={selectedRows.has(i)}
                    onChange={() => updateSelectedRows(i)}
                    className="mr-2"
                  />
                  {i + 1}
                </td>
                {row.map((cell, j) => (
                  <td key={j} className="border p-2">{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FilteredSheetTable;
